import { Components, Theme } from '@mui/material';

const components: Components<Omit<Theme, 'components'>>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: ({ ownerState, theme }) => ({
      backgroundColor: ownerState.transparent
        ? 'transparent'
        : theme.palette.grayBackground.main,
      maxWidth: 170,
      padding: ownerState.transparent ? theme.spacing(0) : theme.spacing(1.5, 3)
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.grayBackground.main
    })
  }
};

export default { components };
